import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';
import React from 'react';
import AutoCompleteFilter from './AutoCompleteFilter';

const GridAutoCompleteFilter = (
  props: GridCustomFilterCellProps,
  filterValues: string[],
  placeholder: string,
  onChange?: (value: string) => void
) => {
  return (
    <HeaderTdElement
      columnId={props.thProps?.columnId || ''}
      {...props.thProps}
    >
      <AutoCompleteFilter
        {...props}
        data={Array.from(new Set(filterValues)).sort()}
        placeholder={placeholder}
        onChange={(a) => {
          onChange?.(a.value);
          props.onChange(a);
        }}
      />
    </HeaderTdElement>
  );
};

export default GridAutoCompleteFilter;
